import { render } from "./position_change_model.vue?vue&type=template&id=229535c2"
import script from "./position_change_model.vue?vue&type=script&lang=js"
export * from "./position_change_model.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/reduction/inside/positions/position_change_model.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "229535c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('229535c2', __exports__)) {
    console.log('reload')
    api.reload('229535c2', __exports__)
  }
  
  module.hot.accept("./position_change_model.vue?vue&type=template&id=229535c2", () => {
    console.log('re-render')
    api.rerender('229535c2', render)
  })

}


export default __exports__